webpackJsonp([3627797113349,20562973939449,189421664636819,194342569950944],{

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = SecurityShield;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SecurityShield() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "205", height: "205", viewBox: "0 0 205 205" },
	    _react2.default.createElement(
	      "g",
	      { className: "fill-marvel" },
	      _react2.default.createElement("path", { d: "M117.448 61.876c0-8.256-6.692-14.948-14.948-14.948s-14.948 6.692-14.948 14.948v12.813c0 1.179.956 2.135 2.135 2.135h25.625c1.179 0 2.135-.956 2.135-2.135v-12.813zM205 16.682c-.056-9.195-7.521-16.621-16.716-16.631h-171.551c-9.203.052-16.635 7.53-16.631 16.733l-.102 62.704c.462 60.269 42.483 112.234 101.321 125.298.546.109 1.101.164 1.657.162.574-.002 1.146-.062 1.708-.179 58.72-13.582 100.281-65.916 100.211-126.186l.102-61.901zm-140.938 115.663v-46.979c0-4.717 3.824-8.542 8.542-8.542h2.135v-14.948c0-15.332 12.429-27.76 27.76-27.76 15.332 0 27.76 12.429 27.76 27.76v14.948h2.135c4.717 0 8.542 3.824 8.542 8.542v46.979c0 2.265-.9 4.438-2.502 6.04-1.602 1.602-3.774 2.502-6.04 2.502h-59.792c-4.717 0-8.542-3.824-8.542-8.542z" }),
	      _react2.default.createElement("circle", { cx: "102.5", cy: "113.126", r: "10.677" })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ImageStatsBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _caseStudies = __webpack_require__(78);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OffsetBackground = __webpack_require__(77);
	
	var _OffsetBackground2 = _interopRequireDefault(_OffsetBackground);
	
	var _generalModule = __webpack_require__(249);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageStatsBlock(_ref) {
	  var align = _ref.align,
	      name = _ref.name;
	
	  var assets = _caseStudies2.default[name];
	  var image = assets.statsImage,
	      features = assets.stats;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.overflow },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeS: 'xl', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _OffsetBackground2.default,
	        { height: 60, backgroundColor: 'licorice' },
	        image && _react2.default.createElement(
	          _pageWrap2.default,
	          null,
	          _react2.default.createElement(_Image2.default, _extends({}, image, {
	            color: 'snow--d',
	            hasShadow: false,
	            useImageTag: true
	          }))
	        ),
	        _react2.default.createElement(
	          _pageWrap2.default,
	          { size: 'l' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', sizeS: 'xl', position: 'topBottom', type: 'padding' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { position: 'topBottom', size: '0', sizeM: 'xl', type: 'padding' },
	              _react2.default.createElement(
	                _align2.default,
	                { type: align },
	                _react2.default.createElement(
	                  _maxWidth2.default,
	                  { value: 1000 },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { columns: 3, size: 'l' },
	                    features.slice(0, 3).map(function (item) {
	                      return _react2.default.createElement(
	                        _grid.GridItem,
	                        { key: item.id, columnSpan: 3, columnSpanS: 1 },
	                        _react2.default.createElement(
	                          'span',
	                          { className: _generalModule2.default.item },
	                          _react2.default.createElement(
	                            _heading2.default,
	                            {
	                              color: 'white',
	                              tag: 'div',
	                              size: 'xxxl',
	                              weight: 'semibold'
	                            },
	                            item.stat
	                          ),
	                          _react2.default.createElement(
	                            _spacing2.default,
	                            {
	                              size: 'm',
	                              position: 'topBottom',
	                              type: 'margin'
	                            },
	                            _react2.default.createElement(
	                              _heading2.default,
	                              {
	                                color: 'silver',
	                                size: 'xl',
	                                tag: 'h3',
	                                weight: 'semibold'
	                              },
	                              item.title
	                            )
	                          ),
	                          item.copy && _react2.default.createElement(
	                            _paragraph2.default,
	                            { tag: 'p', color: 'silver', size: 'l' },
	                            item.copy
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	ImageStatsBlock.propTypes = {
	  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  name: _customPropTypesCheck2.default
	};
	
	ImageStatsBlock.defaultProps = {
	  align: 'center'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overflow":"src-components-modules-ContentBlocks-ImageStats-style----general-module---overflow---UHEC9 bg-licorice breakPointM-bg-none overflow-hidden","container":"src-components-modules-ContentBlocks-ImageStats-style----general-module---container---1pc9V bg-licorice","item":"src-components-modules-ContentBlocks-ImageStats-style----general-module---item---C-m59 textAlign-left"};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BuzzfeedFull = __webpack_require__(183);
	
	var _BuzzfeedFull2 = _interopRequireDefault(_BuzzfeedFull);
	
	var _cover2x = __webpack_require__(113);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(333);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(327);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(328);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(329);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(330);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image032x = __webpack_require__(331);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	var _quote2x = __webpack_require__(332);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buzzfeedAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    maxWidth: 504,
	    alt: ''
	  },
	  heroLogo: _BuzzfeedFull2.default,
	  statsImage: {
	    src: _stats2x2.default,
	    srcSet: _stats2x2.default,
	    maxWidth: 1290,
	    alt: ''
	  },
	  stats: [{
	    id: 0,
	    stat: '700',
	    title: 'Projects',
	    copy: 'Marvel supports their global business scale of work and high project activity'
	  }, {
	    id: 1,
	    stat: '6000',
	    title: 'Designs',
	    copy: 'Marvel high number of designs uploaded by their 20 strong design team '
	  }, {
	    id: 2,
	    stat: '55',
	    title: 'Users',
	    copy: 'Designers use Marvel to share work with content and other teams across the company '
	  }],
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    second: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 490,
	      copy: '"Marvel is a tool in our designers’ toolkit for them to share their work and what stage it’s in with the rest of the team"'
	    }],
	    third: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }]
	  }
	};
	
	exports.default = buzzfeedAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CabifyFull = __webpack_require__(185);
	
	var _CabifyFull2 = _interopRequireDefault(_CabifyFull);
	
	var _stats22x = __webpack_require__(342);
	
	var _stats22x2 = _interopRequireDefault(_stats22x);
	
	var _image00A2x = __webpack_require__(334);
	
	var _image00A2x2 = _interopRequireDefault(_image00A2x);
	
	var _image00B2x = __webpack_require__(335);
	
	var _image00B2x2 = _interopRequireDefault(_image00B2x);
	
	var _image01A2x = __webpack_require__(336);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(337);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(338);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02C2x = __webpack_require__(339);
	
	var _image02C2x2 = _interopRequireDefault(_image02C2x);
	
	var _quote2x = __webpack_require__(341);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	var _image032x = __webpack_require__(340);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cabifyAssets = {
	  heroLogo: _CabifyFull2.default,
	  statsImage: {
	    src: _stats22x2.default,
	    srcSet: _stats22x2.default,
	    alt: ''
	  },
	  stats: [{
	    id: 0,
	    stat: '15 mins',
	    title: 'Feedback time',
	    copy: 'Marvel’s commenting and collaboration features closed feedback loops for Cabify.'
	  }, {
	    id: 1,
	    stat: '1 week',
	    title: 'Shipping time',
	    copy: 'Cabify accelerate their design process through prototyping and testing with Marvel'
	  }, {
	    id: 2,
	    stat: '400%',
	    title: 'Time reduction',
	    copy: 'The team have seen a 400% reduction in time it takes to design and prototype new features'
	  }],
	  doubleImages: {
	    zero: [{
	      src: _image00A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image00B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }],
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    second: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 490,
	      copy: '"Marvel has become the first touch point between designers and the rest of the team."'
	    }],
	    third: [{
	      src: _image02A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image02C2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  }
	};
	
	exports.default = cabifyAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cookpadFull = __webpack_require__(197);
	
	var _cookpadFull2 = _interopRequireDefault(_cookpadFull);
	
	var _stats2x = __webpack_require__(352);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(343);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(344);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(345);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(346);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(347);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(348);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image04A2x = __webpack_require__(349);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04BAlternative2x = __webpack_require__(350);
	
	var _image04BAlternative2x2 = _interopRequireDefault(_image04BAlternative2x);
	
	var _quote2x = __webpack_require__(351);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookPadAssets = {
	  heroLogo: _cookpadFull2.default,
	  statsImage: {
	    alt: 'Marvel Prototyping used by CookPad',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '100',
	    title: 'validation tests',
	    copy: 'Cookpad run tests with Marvel for Product Discovery across 5 squads each week'
	  }, {
	    id: 1,
	    stat: '35',
	    title: 'countries globally',
	    copy: 'Their design teams test with their international audiences around the world using Marvel prototypes'
	  }, {
	    id: 2,
	    stat: '100',
	    title: 'million users',
	    copy: 'Every month Cookpad has over 100 million users visit their platform'
	  }],
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'collaboration'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: 'team meetings'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 550,
	      alt: 'iOS prototyping'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 550,
	      alt: 'cooking'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 556,
	      alt: 'Cookpad and Marvel'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 556,
	      alt: 'Marvel and Cookpad'
	    }],
	    fourth: [{
	      src: _image04A2x2.default,
	      maxWidth: 556,
	      alt: 'Cookpad and Marvel'
	    }, {
	      src: _image04BAlternative2x2.default,
	      maxWidth: 550,
	      alt: 'iOS and desktop prototyping'
	    }],
	    fifth: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: 'mobile prototyping'
	    }, {
	      maxWidth: 440,
	      copy: '“We use the Sketch integration primarily, which syncs with Marvel and instantly updates as we need to. It takes no time at all.”'
	    }]
	  }
	};
	
	exports.default = cookPadAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DeliverooFull = __webpack_require__(186);
	
	var _DeliverooFull2 = _interopRequireDefault(_DeliverooFull);
	
	var _cover2x = __webpack_require__(114);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(362);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(353);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(354);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(355);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(356);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(357);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(358);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image04A2x = __webpack_require__(359);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(360);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _imageQuote2x = __webpack_require__(361);
	
	var _imageQuote2x2 = _interopRequireDefault(_imageQuote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliverooAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    alt: '',
	    maxWidth: 504
	  },
	  heroLogo: _DeliverooFull2.default,
	  statsImage: {
	    alt: '',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '2+',
	    title: 'Years as a Marvel customer',
	    copy: 'Deliveroo have been prototyping and scaling at pace with Marvel since November 2015'
	  }, {
	    id: 1,
	    stat: '20',
	    title: 'Designers using Marvel',
	    copy: 'Their team of 20 designers use Marvel to share designs, prototypes and iterate fast.'
	  }, {
	    id: 2,
	    stat: '15',
	    title: 'Research & content users',
	    copy: 'Marvel isn\'t restricted to designers at Deliveroo, it fits with their collaborative culture'
	  }],
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: ''
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }],
	    fourth: [{
	      src: _imageQuote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 440,
	      copy: '"We use Marvel a lot for user testing. Actually being able to create a scenario, prepare a flow for a person and have them walk through it step-by-step creates such valuable feedback."'
	    }],
	    fifth: [{
	      src: _image04A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }]
	  }
	};
	
	exports.default = deliverooAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DesignMuseumFull = __webpack_require__(187);
	
	var _DesignMuseumFull2 = _interopRequireDefault(_DesignMuseumFull);
	
	var _stats2x = __webpack_require__(374);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(363);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(364);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(365);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(366);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(367);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(368);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image042x = __webpack_require__(371);
	
	var _image042x2 = _interopRequireDefault(_image042x);
	
	var _image04A2x = __webpack_require__(369);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(370);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _image05A2x = __webpack_require__(372);
	
	var _image05A2x2 = _interopRequireDefault(_image05A2x);
	
	var _image05B2x = __webpack_require__(373);
	
	var _image05B2x2 = _interopRequireDefault(_image05B2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var designMuseumAssets = {
	  heroLogo: _DesignMuseumFull2.default,
	  statsImage: {
	    alt: 'students using Marvel Prototyping',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '216+',
	    title: 'design students',
	    copy: 'joined their app design workshop since the beginning of 2017/2018'
	  }, {
	    id: 1,
	    stat: '20',
	    title: 'students per session',
	    copy: 'The Design Museum has small sized classes to provide students with a tailored experience '
	  }, {
	    id: 2,
	    stat: '5',
	    title: 'minutes or less',
	    copy: 'is the time it takes to introduce Marvel to the kids and get them started with their project'
	  }],
	  singleImages: {
	    first: {
	      src: _image042x2.default,
	      maxWidth: 1141,
	      alt: 'Students use Marvel’s Design Tool'
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'Design Museum Interior'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: 'Teacher teaching students how to use Marvel Prototyping'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 580,
	      alt: 'Paper sketching of prototypes'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 558,
	      alt: 'Students start their first project using Marvel'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: 'paper prototyping'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 550,
	      alt: 'Students using Marvel on desktop'
	    }],
	    fourth: [{
	      src: _image04A2x2.default,
	      maxWidth: 460,
	      alt: 'Students using Marvel on desktop'
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 460,
	      alt: 'Marvel Prototyping and Design Museum'
	    }],
	    fifth: [{
	      src: _image05A2x2.default,
	      maxWidth: 556,
	      alt: 'Students using Marvel on desktop'
	    }, {
	      src: _image05B2x2.default,
	      maxWidth: 556,
	      alt: 'Students using Marvel on desktop'
	    }]
	  }
	};
	
	exports.default = designMuseumAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var enterpriseAssets = {
	  stats: [{
	    id: 0,
	    stat: '30%',
	    title: 'Faster',
	    copy: 'Experience seamless collaboration across teams and accelerated creative workflows.'
	  }, {
	    id: 1,
	    stat: '75%',
	    title: 'Of the Fortune 100',
	    copy: "Trusted partner of over 100,000 organisations, including the world's largest."
	  }, {
	    id: 2,
	    stat: '99.9%',
	    title: 'Uptime SLA',
	    copy: 'Reliability is critical to any products success, we pride ourselves on always being there.'
	  }]
	};
	
	exports.default = enterpriseAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HudlFull = __webpack_require__(188);
	
	var _HudlFull2 = _interopRequireDefault(_HudlFull);
	
	var _cover2x = __webpack_require__(113);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(383);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image00A2x = __webpack_require__(375);
	
	var _image00A2x2 = _interopRequireDefault(_image00A2x);
	
	var _image00B2x = __webpack_require__(376);
	
	var _image00B2x2 = _interopRequireDefault(_image00B2x);
	
	var _image01A2x = __webpack_require__(377);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(378);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image022x = __webpack_require__(379);
	
	var _image022x2 = _interopRequireDefault(_image022x);
	
	var _image03A2x = __webpack_require__(380);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(381);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _quote2x = __webpack_require__(382);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hudlAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    alt: ''
	  },
	  heroLogo: _HudlFull2.default,
	  statsImage: {
	    src: _stats2x2.default,
	    srcSet: _stats2x2.default,
	    maxWidth: 1290,
	    alt: ''
	  },
	  stats: [{
	    id: 0,
	    stat: '2x',
	    title: 'Prototyping speed',
	    copy: 'Hudl found that their designers created prototypes twice as fast with Marvel'
	  }, {
	    id: 1,
	    stat: '160+',
	    title: 'Screens in a project',
	    copy: 'Marvel enables Hudl’s high fidelity, large scale prototypes which reach 160 screens'
	  }, {
	    id: 2,
	    stat: '16',
	    title: 'Concurrent projects',
	    copy: 'Hudl work on 16+ projects at a time and Marvel gives them a stable, solid platform to do so '
	  }],
	  doubleImages: {
	    zero: [{
	      src: _image00A2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }, {
	      src: _image00B2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }],
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }],
	    second: [{
	      src: _image03A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }],
	    third: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 520,
	      copy: '"We don’t release anything without some kind of testing. Every morning in our Slack channel we get an automatic update for our research department with scheduled research events. We test daily."'
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image022x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  }
	};
	
	exports.default = hudlAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _buzzfeed = __webpack_require__(212);
	
	var _buzzfeed2 = _interopRequireDefault(_buzzfeed);
	
	var _cabify = __webpack_require__(213);
	
	var _cabify2 = _interopRequireDefault(_cabify);
	
	var _cookpad = __webpack_require__(214);
	
	var _cookpad2 = _interopRequireDefault(_cookpad);
	
	var _deliveroo = __webpack_require__(215);
	
	var _deliveroo2 = _interopRequireDefault(_deliveroo);
	
	var _designmuseum = __webpack_require__(216);
	
	var _designmuseum2 = _interopRequireDefault(_designmuseum);
	
	var _enterprise = __webpack_require__(217);
	
	var _enterprise2 = _interopRequireDefault(_enterprise);
	
	var _hudl = __webpack_require__(218);
	
	var _hudl2 = _interopRequireDefault(_hudl);
	
	var _laboratoria = __webpack_require__(219);
	
	var _laboratoria2 = _interopRequireDefault(_laboratoria);
	
	var _mode = __webpack_require__(220);
	
	var _mode2 = _interopRequireDefault(_mode);
	
	var _monzo = __webpack_require__(221);
	
	var _monzo2 = _interopRequireDefault(_monzo);
	
	var _nokia = __webpack_require__(222);
	
	var _nokia2 = _interopRequireDefault(_nokia);
	
	var _yieldr = __webpack_require__(225);
	
	var _yieldr2 = _interopRequireDefault(_yieldr);
	
	var _security = __webpack_require__(223);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _trusona = __webpack_require__(224);
	
	var _trusona2 = _interopRequireDefault(_trusona);
	
	var _zinc = __webpack_require__(226);
	
	var _zinc2 = _interopRequireDefault(_zinc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  buzzfeed: _buzzfeed2.default,
	  cabify: _cabify2.default,
	  cookpad: _cookpad2.default,
	  deliveroo: _deliveroo2.default,
	  designMuseum: _designmuseum2.default,
	  enterprise: _enterprise2.default,
	  hudl: _hudl2.default,
	  security: _security2.default,
	  laboratoria: _laboratoria2.default,
	  mode: _mode2.default,
	  monzo: _monzo2.default,
	  nokia: _nokia2.default,
	  yieldr: _yieldr2.default,
	  trusona: _trusona2.default,
	  zinc: _zinc2.default
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LaboratoriaFull = __webpack_require__(189);
	
	var _LaboratoriaFull2 = _interopRequireDefault(_LaboratoriaFull);
	
	var _stats2x = __webpack_require__(394);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(384);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(385);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(386);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(387);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image032x = __webpack_require__(390);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	var _image03A2x = __webpack_require__(388);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(389);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image04A2x = __webpack_require__(391);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(392);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _image052x = __webpack_require__(393);
	
	var _image052x2 = _interopRequireDefault(_image052x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var laboratoriaAssets = {
	  heroLogo: _LaboratoriaFull2.default,
	  statsImage: {
	    src: _stats2x2.default,
	    srcSet: _stats2x2.default,
	    maxWidth: 1290,
	    alt: 'Laboratoria at ideation stage'
	  },
	  stats: [{
	    id: 0,
	    stat: '80%',
	    title: 'employment success rate',
	    copy: 'Laboratoria hopes to increase their graduate employment success rate to 85%.'
	  }, {
	    id: 1,
	    stat: '800+',
	    title: 'students',
	    copy: 'Since their launch in 2014 Laboratoria have taught more than 800 students in their program.'
	  }, {
	    id: 2,
	    stat: '200+',
	    title: 'UX design graduates',
	    copy: 'since introducing their UX Design course in 2017, which uses Marvel.'
	  }],
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'Laboratoria plan projects'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 550,
	      alt: 'Laboratoria and Marvel App'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: 'Laboratoria Study Sessions'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: 'Code Editor at Laboratoria'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 556,
	      alt: 'planning and strategy'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 556,
	      alt: 'planning and strategy'
	    }],
	    fourth: [{
	      src: _image04A2x2.default,
	      maxWidth: 556,
	      alt: 'collaboration at Laboratoria with Marvel App'
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 556,
	      alt: 'collaboration at Laboratoria with Marvel App'
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: 'team work at Laboratoria'
	    },
	    second: {
	      src: _image052x2.default,
	      maxWidth: 1141,
	      alt: 'team work at Laboratoria'
	    }
	  }
	};
	
	exports.default = laboratoriaAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ModeFull = __webpack_require__(191);
	
	var _ModeFull2 = _interopRequireDefault(_ModeFull);
	
	var _image01A2x = __webpack_require__(395);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(396);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image032x = __webpack_require__(397);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	var _image04A2x = __webpack_require__(398);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(399);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _image05A2x = __webpack_require__(400);
	
	var _image05A2x2 = _interopRequireDefault(_image05A2x);
	
	var _image05B2x = __webpack_require__(401);
	
	var _image05B2x2 = _interopRequireDefault(_image05B2x);
	
	var _stats2x = __webpack_require__(403);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _quote2x = __webpack_require__(402);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modeAssets = {
	  heroLogo: _ModeFull2.default,
	  statsImage: {
	    alt: 'Mode employee’s working in open office space',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: 'A meeting in Mode'
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'Person working with charts and analytic tools'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: 'People working with charts and analytic tools'
	    }],
	    second: [{
	      src: _image04A2x2.default,
	      maxWidth: 600,
	      alt: 'Developer uses Handoff with Marvel'
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 600,
	      alt: 'Prototyping with Marvel at Mode'
	    }],
	    third: [{
	      src: _image05A2x2.default,
	      maxWidth: 600,
	      alt: 'Mode employees working with analytics'
	    }, {
	      src: _image05B2x2.default,
	      maxWidth: 600,
	      alt: 'Mode employees working with analytics'
	    }],
	    fourth: [{
	      src: _quote2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      maxWidth: 450,
	      copy: '“Handoff is actually the biggest thing that we use on the product team. I can′t tell you how much time it saves in terms of making redlines or helping go back and forth with front-end engineering about anything from padding to colours to font weights."'
	    }]
	  },
	  stats: [{
	    id: 0,
	    stat: '1,260',
	    title: 'comments',
	    copy: 'on Marvel prototypes between design, product managers, engineers, and marketing'
	  }, {
	    id: 1,
	    stat: '140',
	    title: 'projects',
	    copy: 'spanning various product areas and marketing functions'
	  }, {
	    id: 2,
	    stat: '3',
	    title: 'hours',
	    copy: 'of time saved per project with Prototypes and Handoff'
	  }]
	};
	
	exports.default = modeAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MonzoFull = __webpack_require__(192);
	
	var _MonzoFull2 = _interopRequireDefault(_MonzoFull);
	
	var _cover2x = __webpack_require__(114);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _image01a2x = __webpack_require__(404);
	
	var _image01a2x2 = _interopRequireDefault(_image01a2x);
	
	var _image01b2x = __webpack_require__(405);
	
	var _image01b2x2 = _interopRequireDefault(_image01b2x);
	
	var _image02a2x = __webpack_require__(406);
	
	var _image02a2x2 = _interopRequireDefault(_image02a2x);
	
	var _image02b2x = __webpack_require__(407);
	
	var _image02b2x2 = _interopRequireDefault(_image02b2x);
	
	var _image03a2x = __webpack_require__(408);
	
	var _image03a2x2 = _interopRequireDefault(_image03a2x);
	
	var _image04a2x = __webpack_require__(409);
	
	var _image04a2x2 = _interopRequireDefault(_image04a2x);
	
	var _image05a2x = __webpack_require__(410);
	
	var _image05a2x2 = _interopRequireDefault(_image05a2x);
	
	var _image05b2x = __webpack_require__(411);
	
	var _image05b2x2 = _interopRequireDefault(_image05b2x);
	
	var _monzoStats2x = __webpack_require__(412);
	
	var _monzoStats2x2 = _interopRequireDefault(_monzoStats2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monzoAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    alt: ''
	  },
	  heroLogo: _MonzoFull2.default,
	  statsImage: {
	    alt: '',
	    maxWidth: 1290,
	    src: _monzoStats2x2.default
	  },
	  singleImages: {
	    first: {
	      src: _image04a2x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01a2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image01b2x2.default,
	      maxWidth: 551,
	      alt: ''
	    }],
	    second: [{
	      src: _image02a2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }, {
	      src: _image05b2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    third: [{
	      src: _image03a2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      maxWidth: 400,
	      copy: '"The last designer to join the team, she was onboarded with Marvel in 30 minutes, which is really quick."'
	    }],
	    fourth: [{
	      src: _image05a2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image02b2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }]
	  },
	  stats: [{
	    id: 0,
	    stat: '3000',
	    title: 'Artboards',
	    copy: "Marvel is compatible with Sketch and supported the team's big projects"
	  }, {
	    id: 1,
	    stat: '100+',
	    title: 'Prototypes',
	    copy: 'Marvel enables the team to scale and supports high volumes of projects'
	  }, {
	    id: 2,
	    stat: '2',
	    title: 'Weeks to Ship',
	    copy: 'Prototyping with Marvel allows the team to accelerate their entire design process'
	  }]
	};
	
	exports.default = monzoAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NokiaFull = __webpack_require__(193);
	
	var _NokiaFull2 = _interopRequireDefault(_NokiaFull);
	
	var _nokiaHero = __webpack_require__(415);
	
	var _nokiaHero2 = _interopRequireDefault(_nokiaHero);
	
	var _nokia = __webpack_require__(413);
	
	var _nokia2 = _interopRequireDefault(_nokia);
	
	var _nokia3 = __webpack_require__(414);
	
	var _nokia4 = _interopRequireDefault(_nokia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nokiaAssets = {
	  heroLogo: _NokiaFull2.default,
	  statsImage: {
	    src: _nokiaHero2.default,
	    srcSet: _nokiaHero2.default,
	    alt: 'A large Nokia logo on a wall'
	  },
	  stats: [{
	    id: 0,
	    stat: '90,000',
	    title: 'Employees',
	    copy: 'Located all around the world'
	  }, {
	    id: 1,
	    stat: '5',
	    title: 'UX design team locations',
	    copy: 'The UX teams are spread across India, Bulgaria, Canada, Portugal and Finland. Marvel helps them work successfully across all these different time zones.'
	  }, {
	    id: 2,
	    stat: '320',
	    title: 'People using Marvel',
	    copy: 'All happily collaborating on design ideas, across the entire company.'
	  }],
	  singleImages: {
	    first: {
	      src: _nokia2.default,
	      srcSet: _nokia2.default,
	      alt: 'Two people sit at a table with laptops having a discussion',
	      maxWidth: 1350
	    },
	    second: {
	      src: _nokia4.default,
	      srcSet: _nokia4.default,
	      alt: 'A group of people sit around a table in a meeting room',
	      maxWidth: 1350
	    }
	  }
	};
	
	exports.default = nokiaAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var securityAssets = {
	  stats: [{
	    id: 0,
	    stat: '99.98%',
	    title: 'Uptime SLA',
	    copy: 'Our distributed infrastructure means you get the best and most reliable experience possible, no matter where your business is located'
	  }, {
	    id: 1,
	    stat: '24/7',
	    title: 'Support',
	    copy: 'Our global support team covers each timezone, with escalation procedures​ to ensure that urgent issues are swiftly resolved'
	  }, {
	    id: 2,
	    stat: 'GDPR',
	    title: 'Compliant',
	    copy: 'Marvel is fully commited to meeting our legal obligation with the latest GDPR regulation and protecting the data rights of our customers'
	  }]
	};
	
	exports.default = securityAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TrusonaFull = __webpack_require__(194);
	
	var _TrusonaFull2 = _interopRequireDefault(_TrusonaFull);
	
	var _stats22x = __webpack_require__(421);
	
	var _stats22x2 = _interopRequireDefault(_stats22x);
	
	var _image_01_a2x = __webpack_require__(416);
	
	var _image_01_a2x2 = _interopRequireDefault(_image_01_a2x);
	
	var _image_01_b2x = __webpack_require__(417);
	
	var _image_01_b2x2 = _interopRequireDefault(_image_01_b2x);
	
	var _image_02_a2x = __webpack_require__(418);
	
	var _image_02_a2x2 = _interopRequireDefault(_image_02_a2x);
	
	var _image_02_b2x = __webpack_require__(419);
	
	var _image_02_b2x2 = _interopRequireDefault(_image_02_b2x);
	
	var _image_032x = __webpack_require__(420);
	
	var _image_032x2 = _interopRequireDefault(_image_032x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trusonaAssets = {
	  heroLogo: _TrusonaFull2.default,
	  statsImage: {
	    src: _stats22x2.default,
	    srcSet: _stats22x2.default,
	    alt: 'Tursona and Marvel App'
	  },
	  stats: [{
	    id: 0,
	    stat: '5',
	    title: 'mins from paper to prototype',
	    copy: 'Taking rough sketches and turning them into “tappable” prototypes to test before investing time in producing final assets.'
	  }, {
	    id: 1,
	    stat: '2x',
	    title: 'faster meetings with Marvel prototypes',
	    copy: 'Communicating with prototypes means visualizing flows twice as fast.'
	  }, {
	    id: 2,
	    stat: '4',
	    title: 'continents collaborating on a single project',
	    copy: 'Marvel allows Trusona to collaborate across borders and time zones seamlessly.'
	  }],
	  doubleImages: {
	    zero: [{
	      src: _image_01_a2x2.default,
	      maxWidth: 556,
	      alt: 'Marvel on Mobile and Desktop'
	    }, {
	      src: _image_01_b2x2.default,
	      maxWidth: 556,
	      alt: 'Marvel facilitates Trusona’s workflow'
	    }],
	    first: [{
	      src: _image_02_a2x2.default,
	      maxWidth: 550,
	      alt: 'Trusona and Marvel Prototyping'
	    }, {
	      src: _image_02_b2x2.default,
	      maxWidth: 494,
	      alt: 'Trusona and Marvel Prototyping'
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image_032x2.default,
	      maxWidth: 1141,
	      alt: 'Trusona and Marvel Prototyping'
	    }
	  }
	};
	
	exports.default = trusonaAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YieldrFull = __webpack_require__(195);
	
	var _YieldrFull2 = _interopRequireDefault(_YieldrFull);
	
	var _cover2x = __webpack_require__(422);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(433);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(424);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(425);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(426);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(427);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(428);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(429);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image052x = __webpack_require__(431);
	
	var _image052x2 = _interopRequireDefault(_image052x);
	
	var _image002x = __webpack_require__(423);
	
	var _image002x2 = _interopRequireDefault(_image002x);
	
	var _image042x = __webpack_require__(430);
	
	var _image042x2 = _interopRequireDefault(_image042x);
	
	var _quote2x = __webpack_require__(432);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var yieldrAssets = {
	  heroImage: {
	    alt: '',
	    maxWidth: 504,
	    src: _cover2x2.default
	  },
	  heroLogo: _YieldrFull2.default,
	  statsImage: {
	    alt: '',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '30%',
	    title: 'Productivity increase',
	    copy: 'With Marvel’s Handoff tool, design and engineering worked together seamlessly'
	  }, {
	    id: 1,
	    stat: '4x',
	    title: 'Designs shipped',
	    copy: 'Marvel prototypes improved comms and reduced stakeholder back and forth'
	  }, {
	    id: 2,
	    stat: '200%',
	    title: 'Time reduction',
	    copy: 'With Marvel, decision making timeframes were faster and smoother'
	  }],
	  singleImages: {
	    first: {
	      src: _image002x2.default,
	      maxWidth: 1141,
	      alt: ''
	    },
	    second: {
	      src: _image052x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }],
	    third: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 490,
	      copy: '“It saves time in figuring out which prototype connects to which project. I don’t have to go back through Slack or email to find specs for a prototype or if it’s the latest one.”'
	    }],
	    fourth: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }],
	    singleImages: {
	      first: {
	        src: _image042x2.default,
	        maxWidth: 1141,
	        alt: ''
	      }
	    }
	  }
	};
	
	exports.default = yieldrAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ZincFull = __webpack_require__(196);
	
	var _ZincFull2 = _interopRequireDefault(_ZincFull);
	
	var _stats2x = __webpack_require__(445);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(434);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(435);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(436);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(437);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(438);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(439);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image05A2x = __webpack_require__(440);
	
	var _image05A2x2 = _interopRequireDefault(_image05A2x);
	
	var _image05B2x = __webpack_require__(441);
	
	var _image05B2x2 = _interopRequireDefault(_image05B2x);
	
	var _image06A2x = __webpack_require__(442);
	
	var _image06A2x2 = _interopRequireDefault(_image06A2x);
	
	var _image06B2x = __webpack_require__(443);
	
	var _image06B2x2 = _interopRequireDefault(_image06B2x);
	
	var _quote2x = __webpack_require__(444);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zincAssets = {
	  heroLogo: _ZincFull2.default,
	  statsImage: {
	    alt: 'Zinc and Marvel Prototyping',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '55',
	    title: 'skilled individuals',
	    copy: 'From 800 applicants to their programme Zinc chooses a diversely skilled 55.'
	  }, {
	    id: 1,
	    stat: '2',
	    title: 'week bootcamp',
	    copy: 'Successful applicants are given an overview of the challenge they’re solving.'
	  }, {
	    id: 2,
	    stat: '6',
	    title: 'month programme',
	    copy: 'Helping them find business partners, gain access to funding, industry leaders and resources.'
	  }],
	
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc Events'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc Events'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: 'Zinc and Amble'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: 'Amble and Marvel'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: 'Leika uses Marvel'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 500,
	      alt: 'Leika and Marvel App'
	    }],
	    fourth: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: 'Squad uses Marvel App'
	    }, {
	      maxWidth: 490,
	      copy: '“It’s one thing saying we’re going to create something but once you start making it on Marvel it’s not just a prototype to show to investors anymore. It’s also a tool to get your head straight and make both small scale design decisions and the high level decisions.”'
	    }],
	    fifth: [{
	      src: _image05A2x2.default,
	      maxWidth: 550,
	      alt: 'Zone and Marvel App'
	    }, {
	      src: _image05B2x2.default,
	      maxWidth: 550,
	      alt: 'Zone prototypes with Marvel'
	    }],
	    sixth: [{
	      src: _image06A2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc Events'
	    }, {
	      src: _image06B2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc founder, Julia'
	    }]
	  }
	};
	
	exports.default = zincAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover@2x-5739a27022a0e97ae58ab70974d3e01f.jpg";

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-2aa138035be714be0a0460d67eebe746.jpg";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-61c851e8c7bd5e358840c6e63db97997.jpg";

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-49d46fbc13a9e044d670b63f1d49b084.jpg";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-2ecdd75e6c0d3edf925ac4e3ccd13d82.jpg";

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-a368194acf6d6daeb010510e0f9e4f16.jpg";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-15f8b0eb1f5b62d1b98f74660b1c1dff.jpg";

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-aecaf5a98a61460c23584ebf810c29f3.jpg";

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-a@2x-7e0e3bb31ca6932c5b9d40fd3729ce87.jpg";

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-b@2x-97b9a735c51d1e5da87012a7686098c6.jpg";

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-393d0ae0cfb291a0bc3c31737f493bd0.jpg";

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-c4d8ea9a92af38e22acf62c75901b235.jpg";

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-bf02ff6ea5b8a15ba0632becc5b02251.jpg";

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-c@2x-eb15f7d387c35118e90bc2422470e46c.jpg";

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-f12a33a9f4698b0fbf7de797815d42e5.jpg";

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-ae65b8497e75574619f1d6eca353a849.jpg";

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats2@2x-9fd26821fdf74d962ce819615d35cd3b.jpg";

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-9b2d232329a1c795838bc336e0311f65.jpg";

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-72f1c7f9fec01d8eb47b8598aafc3d34.jpg";

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-0c480e0c6ddb36b027c0c788b1de56c4.jpg";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-3845d2b446ebb7420332e5c87f989d96.jpg";

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-8e82851713236dbee305bd44fff0ca0f.jpg";

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-7eb8094798e2641bcfeb0bb6c4b03315.png";

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-fefbab30c118cb201ac3b3d81090cf07.jpg";

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b-alternative@2x-1eb9fac4f6f39f8eee04dd52ef663978.jpg";

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-947b11410d2f7cf4180f0891142d1b1e.jpg";

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-4dfe18b20595cc00d181dacf2a48f913.jpg";

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover@2x-01da721ad0cf618f403934b7982d7aeb.jpg";

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-747cda8d641bc6ce1a52c82a5045fc71.jpg";

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-09b2b40716cd00b38368a9ef65e3f0a5.jpg";

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-b25c9632e92a061538f336647b696ec3.jpg";

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-5fa0f2e3b6aac9e6f8f8facd04ec6052.jpg";

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-602acd346151dc614837cb959e7af272.jpg";

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-fde5a286d1172cd55b02cbb70a54bc74.jpg";

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-86c9850686a64f272ca3016cb5afd28e.jpg";

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-3afc6cb401305276c662056bcfe74cf5.jpg";

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-quote@2x-9bc5f1b136c126251f646562a0be1c1a.jpg";

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-31a8ccc8eb9971a69e18c894b0007a73.jpg";

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-91e0908320d5bf6010fde73e8da4cf7c.jpg";

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-f8ad94cc009e90e79b2612fbd66d34f8.jpg";

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-f52d03a708c39df5a5179d117a828227.jpg";

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-c5c0488cb68e423ecd5dad5449e9127d.jpg";

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-214a5cf6de6f727574638d155464b9c7.jpg";

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-972987e12b5576244b7ab50e14f419ec.jpg";

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-8a0e2b8fe0334fd910eb59276ab8f900.jpg";

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-ec035cb3fd235e0952ed63197f9a6abb.jpg";

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04@2x-396f7dc292945410119c0e3c52840466.jpg";

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-a@2x-92af9cf58bf9a006f0b9b2920e9e27c3.jpg";

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-b@2x-37bea213019b385424282c00226ea8c5.jpg";

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-c87a87bfed76da83acea4e2b0ec56a1c.jpg";

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-a@2x-7a63da9770dba1393010fa038a87e4c7.jpg";

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-b@2x-4185296ef706b76c88e328ce063fb0ee.jpg";

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-45b0d4f6d626b978ce4caf645b682064.jpg";

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-dbfb10cb9e4b3f7523fcbfbc81af4d4f.jpg";

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02@2x-222831c8b795abc5695591f0e64d703f.jpg";

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-9c7a2e76a757bb8a69d8076e90af9055.jpg";

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-dcf08317fbcfaf1da4d973c1b2e0dfdb.jpg";

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-d05e03d36cacaa83cadf86b56d248a4f.jpg";

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-2f0b9ed5dee042f85851697f1e388870.jpg";

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-d6d5198162b1422f5e614d1a53b596ea.jpg";

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-01f94f4eb72605b62a128ab95b2fb16e.jpg";

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-838ee5a750d471d777e0a0f8b40f22ca.jpg";

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-093fcfb89ddc8f89c6f9763f8c6c05a8.jpg";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-5cc8dcbeb413b70bc02e37149fab9bf3.jpg";

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-ab94c670d1a776d348b88f5dd1bbbaa5.jpg";

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-092d06a06361a3c1dc535ae212a2a742.jpg";

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-6fe9d505d2220dae37284374243ff1a4.jpg";

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-c58dc78b81dfd1807bfc07fcee802180.jpg";

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05@2x-76d1daf2abb1c6ceb3998c583aa14228.jpg";

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-2284aed33b509b5d3c0c4525f3486c3c.jpg";

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-0fb5bbbcac40cb8a474be0f56dbecad1.jpg";

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-429315b722e605967e2f8364436fd7d6.jpg";

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-f8f6d3970c7900bf0f5aad5cb0bceae2.jpg";

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-79ad2e4c85bfc5c7eb7eac201f37f563.jpg";

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-8e4a4203b7fa8a1097f7b480d8d17566.jpg";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-a@2x-31b0beec90f522c1edeffe8c5091755b.jpg";

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-b@2x-8d7fe22e620bdd644efbb3a3c4fbc2c5.jpg";

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-b2d355a1502bcc1efc3649b5813fc068.jpg";

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-d77b64a167a44d6de574c0e79a31ad1e.jpg";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image01a@2x-562f2a400cebde0a4bb68f16bb8ab892.jpg";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image01b@2x-f9d473f767e966971171a92b9dddbd9a.jpg";

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image02a@2x-b7e3e1f90eed3e04992cce6e69870616.jpg";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image02b@2x-f4b425bd2b2132c87934b850be5bb407.jpg";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image03a@2x-05a5d3dcd85476c0f4f026bec3fde6b0.jpg";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image04a@2x-105f5b27f84d9629cb4226ccfe8eb5a7.jpg";

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image05a@2x-cc08a6e2fa8c808bc6ec60526150c8ef.jpg";

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image05b@2x-254180957d4f59c4b2b3efd3f681a3ea.jpg";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo-stats@2x-cd62492053c0314d28c1bd082fac935e.jpg";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nokia-1-d85ff8ce79b6c0d888790038784aea3a.jpg";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nokia-2-99f43e12145e7250f1105815c4bb6d67.jpg";

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_01_a@2x-07341d92c8967281b2dd7790afdd2203.jpg";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_01_b@2x-c83444f3d890bcd3854bc202cdc6229d.jpg";

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_02_a@2x-719c43a6c7366c153edd5bf469c3537d.jpg";

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_02_b@2x-a6044e39e093336137fe5e5cfbfc10eb.png";

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_03@2x-4ed7ea536b1dcb8ed3833fe655544f88.jpg";

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats2@2x-ed311a628002f546494832053a7420a9.jpg";

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover@2x-f355119c88b4a0d8edad0cca4de99779.jpg";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00@2x-3692cfef2020f4587d1d45e0f8f80811.jpg";

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-787f1bc2674c72bf879db1298beb9b82.jpg";

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-44722bff15fd3dfbc323847452828328.jpg";

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-f4472de86b006d313e998d2b08fe8d09.jpg";

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-d995c482808ae5a9f217ce1d487274d0.jpg";

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-588332452ef8431b24e42875ac51291b.jpg";

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-fa07a57d344bdac4cacf09a29efd9330.jpg";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04@2x-fb789c422bf8599690e3f133e8550991.jpg";

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05@2x-fb789c422bf8599690e3f133e8550991.jpg";

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-39d578091348dbe7f91ddb17ff4bede4.jpg";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-a690649b8636ea59d4a7f18221957b67.jpg";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-3ff2a502ac5efa67e7cd320cbfff3105.jpg";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-645b852e69e1a411ce94f47f38977e86.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-d8dd3235c373e1fc85507568650ab3fe.jpg";

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-a7ecef90243402910f6001e3f833679e.jpg";

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-00825eaca3b633d0d10c472ac2fe95a6.jpg";

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-8900cdede538b1f067bb46bbe64c0c93.png";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-a@2x-17fad6084e8a6c390f809b9076f64827.jpg";

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-b@2x-b274ee2ad5eb2105aedeb17831583b63.jpg";

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-06-a@2x-c0cd541a79c0e98a08c2391b31a1130d.jpg";

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-06-b@2x-a5e7e3274e16a7d53022e64c1659648a.png";

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-69d790331aad119909460889318919ca.jpg";

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-ba8f5ec53dfbe71cf415b69a4f9024cf.jpg";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Actions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Actions() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'l', position: 'bottom' },
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:security@marvelapp.com', className: 'display-block' },
	        _react2.default.createElement(
	          _button2.default,
	          { size: 'large', fullWidth: true },
	          'Speak to the security team'
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Features;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _TickedCopy = __webpack_require__(95);
	
	var _TickedCopy2 = _interopRequireDefault(_TickedCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var features = [{
	  id: 0,
	  copy: 'Hosted in the EU'
	}, {
	  id: 1,
	  copy: 'GDPR Compliant'
	}, {
	  id: 2,
	  copy: 'SAML-based SSO'
	}, {
	  id: 3,
	  copy: 'IP Restriction and account locking'
	}, {
	  id: 4,
	  copy: 'Multi-layer encryption'
	}, {
	  id: 5,
	  copy: 'Full range of user permissions'
	}];
	
	function Features(_ref) {
	  var size = _ref.size;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    features.map(function (item) {
	      return _react2.default.createElement(
	        _spacing2.default,
	        { key: item.id, size: 'xs', position: 'topBottom', type: 'margin' },
	        _react2.default.createElement(
	          _TickedCopy2.default,
	          { size: size },
	          item.copy
	        )
	      );
	    })
	  );
	}
	
	Features.propTypes = {
	  size: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Stats;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageStats = __webpack_require__(198);
	
	var _ImageStats2 = _interopRequireDefault(_ImageStats);
	
	var _statsModule = __webpack_require__(759);
	
	var _statsModule2 = _interopRequireDefault(_statsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Stats() {
	  return _react2.default.createElement(
	    'div',
	    { className: _statsModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _statsModule2.default.centered },
	      _react2.default.createElement('div', { className: _statsModule2.default.whitePiece })
	    ),
	    _react2.default.createElement(_ImageStats2.default, { align: 'center', name: 'security' })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Security;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SecurityShield = __webpack_require__(1152);
	
	var _SecurityShield2 = _interopRequireDefault(_SecurityShield);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _Stats = __webpack_require__(688);
	
	var _Stats2 = _interopRequireDefault(_Stats);
	
	var _Features = __webpack_require__(687);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Actions = __webpack_require__(686);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _generalModule = __webpack_require__(1505);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Security() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default.security.title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default.security.description
	      }],
	      banner: true,
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.security },
	      _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.wrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.leftcol },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: 770 },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _spacing2.default,
	                { type: 'margin', size: 'l', position: 'bottom' },
	                _react2.default.createElement(
	                  _align2.default,
	                  { type: 'center' },
	                  _react2.default.createElement(_SecurityShield2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                _spacing2.default,
	                { type: 'margin', size: 'm', position: 'bottom' },
	                _react2.default.createElement(_Actions2.default, null),
	                _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 'm', position: 'bottom' },
	                  _react2.default.createElement(
	                    _heading2.default,
	                    { tag: 'h3', weight: 'bold', size: 'm' },
	                    'Security features'
	                  )
	                ),
	                _react2.default.createElement(_Features2.default, { size: 'm' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.rightcol },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 's', sizeM: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h1', weight: 'bold', size: 'xxxxl' },
	              'Security at Marvel'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xxxl' },
	              'We\'re committed to protecting the creative work that our customers trust us to store.'
	            )
	          ),
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'margin', size: 'l', position: 'bottom' },
	              _react2.default.createElement(_Actions2.default, null),
	              _react2.default.createElement(
	                _spacing2.default,
	                { type: 'margin', size: 'm', position: 'bottom' },
	                _react2.default.createElement(
	                  _heading2.default,
	                  { tag: 'h3', weight: 'bold', size: 'xxl' },
	                  'Security features'
	                )
	              ),
	              _react2.default.createElement(_Features2.default, { size: 'l' })
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'margin', size: 'm', position: 'bottom' },
	              _react2.default.createElement(
	                _paragraph2.default,
	                { size: 'l', color: 'steel' },
	                'Marvel\u2019s mission is to democratise the design process, making it more productive and inclusive so that everyone has the opportunity to bring their ideas to life. Core to that mission is keeping your ideas, data and projects confidential and secure. We take that responsibility seriously for our 2 million users, ranging from startups to Fortune 100 companies.'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'Here you\u2019ll find more information on how we approach security, if you have additional questions feel free to get in touch at on',
	              ' ',
	              _react2.default.createElement(
	                _link2.default,
	                { url: 'mailto:security@marvelapp.com', type: 'blue' },
	                'security@marvelapp.com'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'Vulnerability disclosure and Reward Program'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'Marvel\u2019s security team works closely with the community to rapidly investigate all reported issues regarding security and bugs on the platform. We value the effort and detail put into reports we receive by the security research community and offer cash rewards based on the severity of issue reported. If you find any security issues please review our',
	              ' ',
	              _react2.default.createElement(
	                _link2.default,
	                { url: '/security/bountypolicy/', type: 'blue' },
	                'Bug Bounty Policy'
	              ),
	              ' ',
	              'before submitting any requests. Any submissions that do not qualify may not be responded to as it requires time for our engineers to review each submissions please ensure you read all scopes for our submission criteria. We endeavour to reply to any real or high impact issues within 7 days of submission with a maximum of 30 days depending on the problem.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'Enterprise Security Features'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'Marvel Enterprise has several additional features that allow customers to enforce several layers of security to their accounts and projects. That includes Single Sign-On (SSO), IP restriction, access logs, user permissions and project-level password protection.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'Communication'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'All user data is transported securely, as all traffic is encrypted in transit via SSL. Encrypting data in transit protects it from unauthorised snooping, modification, and man-in-the-middle attacks. We use 256-bit SSL/TLS.1.2 encryption, utilising both the ECDSA and RSA algorithms.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'Data Centre Security'
	            )
	          ),
	          _react2.default.createElement(
	            _paragraph2.default,
	            { size: 'l', color: 'steel' },
	            'Our hosting environment is fully-redundant with disaster recovery procedures. Our cloud hosting providers maintain multiple certifications for its data centers, including ISO 27001 compliance, PCI certification, and SOC. For more information about their certification and compliance, please visit the',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              {
	                url: 'https://cloud.google.com/security/compliance/#/',
	                type: 'blue'
	              },
	              'Google Cloud Platform'
	            ),
	            ' ',
	            'or',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              { url: 'https://aws.amazon.com/security/', type: 'blue' },
	              'Amazon AWS security'
	            ),
	            ' ',
	            'site.'
	          )
	        )
	      ),
	      _react2.default.createElement(_Stats2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.wrapper },
	        _react2.default.createElement('div', { className: _generalModule2.default.leftcol }),
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.rightcol },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'EU Hosted Infrastructure'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'The Marvel Platform infrastructure is hosted on servers based in the European Union. This allows us to meet specific regulatory and compliance requirements of organisations in Europe, including financial institutions, consultancies and government entities. Our data center provider Google Cloud Platform located in Belgium and Germany maintains multiple certifications, including SOC 1, SOC 2, SOC 3 and ISO27001. In addition all data is encrypted both in transit and at rest using strong encryption.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'Credit Cards'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'l', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'Marvel does not store any credit card information. We have partnered with Stripe for credit card processing which allows us to leverage AES-256 encryption at rest, with PCI Service Provider Level 1 standards in the storage and handling of credit card information. This is the most stringent level of certification available to the payments industry.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'm', position: 'bottom' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h3', weight: 'bold', size: 'xxl' },
	              'Marvel\u2019s GDPR Commitment'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'margin', size: 'xl', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'steel' },
	              'As a Data Controller, Marvel is commited to compliance with the General Data Protection Regulation, and meeting our legal obligation by helping our customers become compliant. We\u2019ve made several key policy, product and term updates that strengthen the protection of personal data and rights of users.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1505:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"security":"src-pages-security-style----general-module---security---3I3u7","wrapper":"src-pages-security-style----general-module---wrapper---1zaVb breakPointM-alignContent-stretch centered display-flex breakPointM-display-flex width-90","rightcol":"src-pages-security-style----general-module---rightcol---1swv0 flex-1","leftcol":"src-pages-security-style----general-module---leftcol---fNHk0"};

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages-security-style----stats-module---container---1PVZg marginTop-l marginBottom-xl paddingTop-m overflow-hidden position-relative bg-licorice","centered":"src-pages-security-style----stats-module---centered---1E91b breakPointM-alignContent-stretch centered position-relative breakPointM-display-flex width-90","whitePiece":"src-pages-security-style----stats-module---whitePiece---9EseT bg-white position-absolute"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-security-index-js-1dc5d7e15309fbb863a6.js